import { z } from 'zod';
import { ConfirmNewPasswordValidation } from 'shared/validation/validationTemplates';

export const EnterNewPasswordFormValidation = ConfirmNewPasswordValidation;

export type TEnterPasswordFormType = z.infer<typeof EnterNewPasswordFormValidation>;
